<template>
  <v-card>
     <v-list two-line subheader>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Title</v-list-item-title>
        <v-list-item-subtitle>{{ doc.title }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Category</v-list-item-title>
        <v-list-item-subtitle>{{ doc.categories }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

     <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Description</v-list-item-title>
        <v-list-item-subtitle>{{ doc.description }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

     <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Steps</v-list-item-title>
        
          <v-chip v-for="(chip, index) in doc.subitems" :key="`show-${index}`">
            {{ chip }}
          </v-chip>
        
      </v-list-item-content>
    </v-list-item>
    

  </v-list>

  </v-card>
</template>

<script>
// @ is an alias to /src
const fb = require("@/firebaseConfig.js");

export default {
  name: "UserServiceShow",
  data() {
    return {
      doc: {},
    };
  },
  props: {
    id: String,
  },
  watch: {
    id(val) {
      this.load(val);
    },
  },
  created() {
    this.load(this.id);
  },
  methods: {
    load(id) {
      const ref = fb.exServiceNotesCollection.doc(id);
      ref.get().then((doc) => {
        if (doc.exists) {
          this.doc = doc.data();
        } else {
          alert("No such document!");
        }
      });
    },
  },
};
</script>
